import React, {useEffect, useState} from 'react';
import {useFormik} from 'formik';
import {connect} from 'react-redux';
import actions from '../../../redux/actions';
import Ebutton from '../../../common/components/Ebutton/Ebutton';
import * as yup from 'yup';
import _ from 'lodash';
import './ResetPass.scss';
import {useHistory, useParams, useRouteMatch} from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import {IconButton, InputAdornment} from '@material-ui/core';
import {Input} from '@mui/material';

const InputErrorMessage = ({formik, name, className = ''}) => {
    return (
        <div className={'form-error ' + className} >
            { _.get( formik.errors, name ) }
        </div>
    );
};

const ResetPass = ({resetPass, logout, resetPasswordState, cleanResetPassState, showSidebar}) => {
    const {token} = useParams();
    const isFirstTime = useRouteMatch('/set-password/:token'); // TODO: it is possible that the last slash should be removed
    const history = useHistory();
    const [showPassword, setShowPassword] = useState(false);
    const [showRePassword, setShowRePassword] = useState(false);

    useEffect(() => {
        logout();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (resetPasswordState?.success) {
            history.replace('/login');
            cleanResetPassState();
        }
        // eslint-disable-next-line
    }, [resetPasswordState?.success]);

    const validationSchema = yup.object({
        pass: yup
            .string('Ingrese contrasena')
            .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*["#@$!%*?&._+=-])[A-Za-z0-9\\d"#@$!%*?&._+=-]{8,}$/,
                'Debe tener 8 caracteres, con minuscula, mayuscula, numero y caracter especial')
            .required('Ingrese contrasena'),
        repass: yup
            .string('Ingrese confirmacion')
            .oneOf([yup.ref('pass'), null], 'Las contrasenas no coinciden')
            .required('Ingrese confirmacion'),
    });
    const formik = useFormik({
        initialValues: {
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            const body = {
                token: token,
                newPassword: values.pass,
            };
            resetPass(body);
            },
    });

    return (
        <div className={showSidebar && window.innerWidth <= 700 ? 'ul-div-background bg-mt-10' : 'ul-div-background'}>
            <div className="chp-div-section">

            <div className="ul-div-sect-header">
                <div>
                    <p className="ul-p-title">{isFirstTime?.isExact ? 'Configure su contraseña' : 'Cambiar contraseña'}</p>
                    <hr id="id-hr"/>
                </div>
            </div>

            <div className="ul-div-form">

                <form className="eu-form" onSubmit={formik.handleSubmit}>

                    <div className="eu-div-container">
                        <div className="eu-div-input">
                            <text className="eu-text-l eu-f-label">Nueva contraseña</text>
                        </div>
                        <div className="eu-div-input">
                            <Input
                                name="pass"
                                type={showPassword ? 'text' : 'password'}
                                onChange={formik.handleChange}
                                value={formik.values.pass}
                                placeholder="Ingrese su contraseña"
                                className="lg-input-password"
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={() => setShowPassword(!showPassword)}
                                        >
                                            {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </div>
                        <div className="eu-div-input">
                            <InputErrorMessage formik={formik} name='pass' className='rp-input-l' />
                        </div>

                        <div className="eu-div-input">
                            <text className="eu-text-l eu-f-label">Repetir contraseña</text>
                        </div>
                        <div className="eu-div-input">
                            <Input
                                name="repass"
                                type={showRePassword ? 'text' : 'password'}
                                onChange={formik.handleChange}
                                value={formik.values.repass}
                                placeholder="Ingrese su contraseña"
                                className="lg-input-password"
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={() => setShowRePassword(!showRePassword)}
                                        >
                                            {showRePassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </div>
                        <div className="eu-div-input">
                            <InputErrorMessage formik={formik} name='repass' className='rp-input-l' />
                        </div>

                        <Ebutton classNameButton="eu-btn" type="submit" text="CAMBIAR"/>
                    </div>

                </form>
            </div>

        </div></div>
    );
};

const mapStateToProps = (state) => ({
    resetPasswordState: state.login.resetPasswordState,
    showSidebar: state.common.showSidebar,
});

const mapDispatchToProps = (dispatch) => ({
    resetPass: (body) => dispatch(actions.login.resetPassRequest(body)),
    logout: () => dispatch(actions.login.logout()),
    cleanResetPassState: () => dispatch(actions.login.cleanResetPassState()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ResetPass);
